export const CyTextEditable = {
  TextEditableValue: "TextEditableValue",
  EditButton: "EditButton",
  InputField: "InputField",
  SaveButton: "SaveButton",
} as const;
